import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/inventory-purchases/new/loading';

export const Route = createFileRoute('/_private/settings/inventory-purchases/new')({
  component: Loading,
});
